// extracted by mini-css-extract-plugin
export default {"root":"yJeJu_","displayNone":"Ivgfu1","okay":"IO8yoG","title":"VhM24p","info":"sdF1so"};